import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

export const getListGenres = (params) => sendGet("/genres", params);

export const createGenres = (params) => sendPost("/genres", params);

export const updateGenres = (id, params) => sendPut(`/genres/${id}`, params);

export const deleteGenres = (id) => sendDelete(`/genres/${id}`);
